import React, { useState, useEffect } from 'react'
import Skeleton from "react-loading-skeleton";
import { getEmailListCommunicatedByUserId, getEmailResendCommunicatedByUserId } from '../AdminActionCreator.component';
import NoData from '../../../../images/nodata.png'
import moment from 'moment';
import PopUp from '../../../presentationals/Popup/Popup.component';

export default function EmaillogsSection({ allDetail }) {
    const [loaderState, setloaderState] = useState(false)
    const [popup, setpopup] = useState({ show: false, popupStatus: "" })
    const [data, setdata] = useState([])

    useEffect(() => {
        getEmailListCommunicatedByUserIdFn()
    }, [])

    const getEmailListCommunicatedByUserIdFn = () => {
        setloaderState(true)
        getEmailListCommunicatedByUserId(allDetail?.userId, callback => {
            setloaderState(false)
            if (callback?.status == 200 && callback?.message == "success") {
                setdata(callback?.data)
            } else {
                setdata([])
            }
        })
    }

    const handleResnd = (id) => {
        setloaderState(true)
        getEmailResendCommunicatedByUserId(id, callback => {
            setloaderState(false)
            if(callback?.message == "success" && callback?.status ==200){

                setpopup({ show: true, popupStatus: "Mail Send Successfully!" })
            }else{

                setpopup({ show: true, popupStatus: "Error Sending Mail!" })
            }
            setTimeout(() => {
                closePopup()
            }, 5000)
        })
    }

    const closePopup = () => {
        setpopup({ show: false, popupStatus: "" })
    }
    return (
        <>
            {
                popup?.show ?
                    <PopUp closePopup={closePopup} popupStatus={popup?.popupStatus} />
                    : ""}
            <div className="animated fadeIn">
                {!loaderState ?
                    < div className="container-fluid details-new  " style={{ marginTop: '80px' }}>
                        <div className="phocket-table-new" >
                            <table>
                                <thead>
                                    <tr>
                                        <th>Date</th>
                                        <th>Fulfilled by</th>

                                        <th style={{ maxWidth: '400px' }}>Subject</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        data && data?.length > 0 ? data?.map((value, id) => {
                                            return (
                                                <tr key={id}>
                                                    <td>{moment(value?.sentTime).format("DD-MM-YYYY HH:MM:SS") || "-"}</td>
                                                    <td>{value?.sender || "-"}</td>
                                                    <td>{value?.subject || "-"}</td>
                                                    <td>{value?.status || "-"}</td>
                                                    <td>
                                                        <button className='btn btn-primary' onClick={() => handleResnd(value?.id)}>Resend</button>
                                                    </td>
                                                </tr>
                                            )
                                        })
                                            : ""}
                                </tbody>
                            </table>
                        </div>
                    </div >
                    :

                    <div className='phocket-table-new' style={{ marginTop: '80px' }}>
                        <table className='text-center '  >
                            <thead>
                                <tr>
                                    <th>Date</th>
                                    <th>Fulfilled by</th>

                                    <th style={{ maxWidth: '400px' }}>Subject</th>
                                    <th>Status</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>


                                </tr>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>

                                </tr>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>

                                </tr>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>

                                </tr>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>

                                </tr>
                                <tr>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>
                                    <td><Skeleton height={40} /></td>

                                </tr>

                            </tbody>
                        </table>
                    </div>}
            </div>
        </>
    )
}
